import script from "./DocumentPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentPreview.vue?vue&type=script&setup=true&lang=js"

import "./DocumentPreview.vue?vue&type=style&index=0&id=6eff9f0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eff9f0c"]])

export default __exports__